import React from 'react';
const PrivacyCookiePage = () => {
  return <div className="bg-white" data-id="element-1574" data-mp="1y0cij6n9ygpq">
      <div className="container mx-auto px-4 py-12" data-id="element-1575" data-mp="3avjs38gnb5t5">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1576" data-mp="3ax3cnb9c430q">
          Privacy & Cookie Policy
        </h1>
        <section className="mb-8" data-id="element-1577" data-mp="2wy3nm2hwtm41">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1578" data-mp="31ubxp1h92p4c">
            1. Privacy Statement
          </h2>
          <p className="mb-4" data-id="element-1579" data-mp="3plhebiv0llfp">
            At <span className="text-burgundy-600" data-id="element-1580" data-mp="3pmj12kle7wd9">N</span>orthampton{' '}
            <span className="text-burgundy-600" data-id="element-1581" data-mp="3ui7sg0n9e6yh">D</span>riving{' '}
            <span className="text-burgundy-600" data-id="element-1582" data-mp="3fv4uxtyxryb5">S</span>chool, we are committed
            to protecting your privacy and handling your personal information
            responsibly, in line with the UK General Data Protection Regulation
            (GDPR) and the Data Protection Act 2018.
          </p>
          <p className="mb-4" data-id="element-1583" data-mp="h54q0g4qz1yc">This policy explains:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1584" data-mp="h6pje2fbseum">
            <li data-id="element-1585" data-mp="2z5g7xp2x61wn">What information we collect</li>
            <li data-id="element-1586" data-mp="2z2aejxn9cdv4">How we use and protect it</li>
            <li data-id="element-1587" data-mp="2u63c4eu2lkhx">Your rights under data protection law</li>
          </ul>
          <p data-id="element-1588" data-mp="37woxqbaws8ji">
            When you use our website or services, you agree to the practices
            described in this policy.
          </p>
        </section>
        <section className="mb-8" data-id="element-1589" data-mp="334p0wrq4xvr5">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1590" data-mp="3huw8gceltud2">
            2. Information We Collect
          </h2>
          <p className="mb-4" data-id="element-1591" data-mp="3cwkzs501ppwf">
            We may collect the following information when you contact us, book
            lessons, or use our website:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1592" data-mp="3qt88f51d24i6">
            <li data-id="element-1593" data-mp="3mvahnxrxzaco">Name, address, email, and phone number</li>
            <li data-id="element-1594" data-mp="1wh9y0zrbf2kp">
              Payment information (processed securely by third-party providers;
              we do not store card details)
            </li>
            <li data-id="element-1595" data-mp="1shrd43zhurhv">
              Enquiry details (such as preferred lesson times, location, or
              driving requirements)
            </li>
            <li data-id="element-1596" data-mp="dvgzxn2oh5i">
              Technical data such as IP address, browser type, and device
              information
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1597" data-mp="5fkvxodf1eyv">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1598" data-mp="ad49em2ahnpr">
            3. How We Use Your Data
          </h2>
          <p className="mb-4" data-id="element-1599" data-mp="ed4zj3yr3ncn">
            We process your personal data for the following purposes:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1600" data-mp="jbokp25isv3y">
            <li data-id="element-1601" data-mp="o3g1ikyvjmgw">To deliver driving lessons and related services</li>
            <li data-id="element-1602" data-mp="o62i1a3qtcb9">To manage bookings and payments</li>
            <li data-id="element-1603" data-mp="t2124li1g85v">
              To communicate with you (lesson reminders, updates, and support)
            </li>
            <li data-id="element-1604" data-mp="y3gmebce6an7">To comply with legal and safety obligations</li>
            <li data-id="element-1605" data-mp="12390f3kk18zy">To improve our website and customer experience</li>
          </ul>
          <p data-id="element-1606" data-mp="2mlt9kjr3h67c">
            We will never sell or share your personal data with third parties
            for marketing purposes. Limited information may be shared with
            trusted providers (such as payment processors or website hosting
            platforms) where required to deliver our services.
          </p>
        </section>
        <section className="mb-8" data-id="element-1607" data-mp="28n20jbr3aaq2">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1608" data-mp="28nv0ntvjm1z8">
            4. Your Rights
          </h2>
          <p className="mb-4" data-id="element-1609" data-mp="36blj6nq15ta7">Under GDPR, you have the right to:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1610" data-mp="31b7l9yi57zpw">
            <li data-id="element-1611" data-mp="2wjph71ktpj0p">Access the personal data we hold about you</li>
            <li data-id="element-1612" data-mp="2whwbpply54ua">Request correction of inaccurate information</li>
            <li data-id="element-1613" data-mp="2rjuqay11stfn">
              Request deletion of your personal data (where legally permissible)
            </li>
            <li data-id="element-1614" data-mp="3p1ut6js26pcg">Object to certain types of processing</li>
            <li data-id="element-1615" data-mp="3k91otx0i5j0w">Withdraw consent for marketing communications</li>
          </ul>
          <p data-id="element-1616" data-mp="34rjz9sjaqrn9">
            To exercise these rights, please email us at
            info@northamptondrivingschool.co.uk.
          </p>
        </section>
        <section className="mb-8" data-id="element-1617" data-mp="38tx1w82qy9ft">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1618" data-mp="38qsruu2lojh8">
            5. Cookie Policy
          </h2>
          <h3 className="text-xl font-bold text-burgundy-600 mb-3" data-id="element-1619" data-mp="2zsfm6qt949rn">
            What Are Cookies?
          </h3>
          <p className="mb-4" data-id="element-1620" data-mp="3nhi501zmg8nq">
            Cookies are small text files stored on your device when you visit
            our website. They help the site function properly, improve your
            browsing experience, and allow us to understand how our website is
            used.
          </p>
          <h3 className="text-xl font-bold text-burgundy-600 mb-3" data-id="element-1621" data-mp="3ir1og90i86x5">
            Types of Cookies We Use
          </h3>
          <h4 className="text-lg font-bold text-burgundy-600 mb-2" data-id="element-1622" data-mp="ab8d08l15lmy">
            a. Strictly Necessary Cookies
          </h4>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1623" data-mp="f3szep1lwwgg">
            <li data-id="element-1624" data-mp="1zs3shpinpb7t">Essential for the website to function.</li>
            <li data-id="element-1625" data-mp="1zqixjysfjq9f">
              Used for actions like logging in, securing the site, and
              processing forms.
            </li>
            <li data-id="element-1626" data-mp="28lgvxlecjv85">Without them, some services may not work properly.</li>
          </ul>
          <h4 className="text-lg font-bold text-burgundy-600 mb-2" data-id="element-1627" data-mp="24jc6yzyufmru">
            b. Functional Cookies
          </h4>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1628" data-mp="1gt9fakyucitr">
            <li data-id="element-1629" data-mp="1gvvmgjhtkwbg">
              Allow us to remember your preferences (e.g., region, language).
            </li>
            <li data-id="element-1630" data-mp="1bx11pc0akxop">Provide enhanced functionality and personalisation.</li>
            <li data-id="element-1631" data-mp="1pvr2b1mblfht">If disabled, some features may not operate as intended.</li>
          </ul>
          <h4 className="text-lg font-bold text-burgundy-600 mb-2" data-id="element-1632" data-mp="1kttbnmblbieu">
            c. Performance Cookies
          </h4>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1633" data-mp="31bpgfjwcurpw">
            <li data-id="element-1634" data-mp="2w9hy8ckxmff4">
              Collect anonymous information about how visitors use the website.
            </li>
            <li data-id="element-1635" data-mp="1twc0fmsnzogi">
              Help us understand which pages are most popular and where
              improvements are needed.
            </li>
            <li data-id="element-1636" data-mp="22xsb7vne5sl9">Data is aggregated and does not personally identify you.</li>
          </ul>
          <h4 className="text-lg font-bold text-burgundy-600 mb-2" data-id="element-1637" data-mp="22vz2mat7wyam">
            d. Targeting & Advertising Cookies
          </h4>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1638" data-mp="1b75nkgejxr2m">
            <li data-id="element-1639" data-mp="1b4j71r9oo189">
              Used to deliver adverts that are more relevant to you and your
              interests.
            </li>
            <li data-id="element-1640" data-mp="1k6sfmble5kj0">May be set by us or advertising partners.</li>
            <li data-id="element-1641" data-mp="1k57kajr95xk3">
              Track browsing activity across websites (with your consent).
            </li>
            <li data-id="element-1642" data-mp="1ozvd2utahe4h">
              If disabled, you will still see adverts, but they may be less
              relevant.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1643" data-mp="wgeul5184lxx">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1644" data-mp="wfd9s8ueol30">
            6. Managing Your Cookies
          </h2>
          <p className="mb-4" data-id="element-1645" data-mp="jzdng15e66wr">
            You can manage or disable cookies at any time through your browser
            settings. However, some features of our website may not function
            correctly without them.
          </p>
          <p className="mb-4" data-id="element-1646" data-mp="axnugqvv2zwv">For more control, you can:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1647" data-mp="5z2v0tofok9h">
            <li data-id="element-1648" data-mp="60no0ev3nv58">
              Adjust cookie preferences through our cookie banner (when visiting
              our site).
            </li>
            <li data-id="element-1649" data-mp="3sensni4kvs8r">Clear cookies in your browser history.</li>
            <li data-id="element-1650" data-mp="3sf70u74ff29l">
              Opt out of personalised advertising via industry tools such as
              www.youronlinechoices.com.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1651" data-mp="3jdpnuxmbfgp4">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1652" data-mp="3jg26lczwdv38">
            7. Data Retention
          </h2>
          <p data-id="element-1653" data-mp="166prz0tougpi">
            We only keep personal data for as long as necessary to provide our
            services and meet legal obligations. Lesson and payment records may
            be kept for up to six years in line with tax and accounting
            requirements.
          </p>
        </section>
        <section className="mb-8" data-id="element-1654" data-mp="1173f4shrv2h8">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1655" data-mp="116224ih745wv">
            8. Changes to This Policy
          </h2>
          <p data-id="element-1656" data-mp="nenjwdv448qv">
            We may update this Privacy & Cookie Policy from time to time.
            Updates will be published on this page with a new "last updated"
            date. Continued use of our website means you accept the updated
            policy.
          </p>
        </section>
        <section className="mb-8" data-id="element-1657" data-mp="ihf1qd9ys4pm">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1658" data-mp="4h44msi29tw0">
            9. Contact Us
          </h2>
          <p className="mb-4" data-id="element-1659" data-mp="9fxlmuwk430x">
            If you have any questions about this Privacy & Cookie Policy or how
            we handle your data, please contact:
          </p>
          <p className="flex items-center space-x-2 mb-1" data-id="element-1660" data-mp="3m1mi9nnbr9xg">
            <span className="text-burgundy-600" data-id="element-1661" data-mp="3h204nd3l3ro4">📧</span>
            <a href="mailto:info@northamptondrivingschool.co.uk" className="text-burgundy-600 hover:text-burgundy-800" data-id="element-1662" data-mp="3v07y3b1ewauj">
              info@northamptondrivingschool.co.uk
            </a>
          </p>
          <p className="flex items-center space-x-2 mb-1" data-id="element-1663" data-mp="8ryksd4rvxl0">
            <span className="text-burgundy-600" data-id="element-1664" data-mp="3ug8qdvgl28s">📞</span>
            <a href="tel:07481300600" className="text-burgundy-600 hover:text-burgundy-800" data-id="element-1665" data-mp="3twqew1wcbu8">
              07481 300 600
            </a>
          </p>
          <p className="flex items-center space-x-2" data-id="element-1666" data-mp="dkhzxej3z0rx">
            <span className="text-burgundy-600" data-id="element-1667" data-mp="rjhkob3i2vit">📍</span>
            <span data-id="element-1668" data-mp="rk0tn2b6a9kp">Northampton Driving School, Northampton, UK</span>
          </p>
        </section>
      </div>
    </div>;
};
export default PrivacyCookiePage;